module.exports = __webpack_public_path__ + "static/media/en-help.70618c0e.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/features/pdfs/en-help.pdf
// module id = 877
// module chunks = 4